import React from 'react';
//import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
import { signOut, manageMyEvents } from "../api/FirebaseAPI";
import { Toolbar, ToolbarRow, ToolbarSection, ToolbarTitle, ToolbarIcon } from 'rmwc/Toolbar';
import "material-components-web/dist/material-components-web.css";
import { SimpleMenu, MenuItem, MenuAnchor } from 'rmwc/Menu';
import './MenuAppBar.css'
import { signIn } from '../api/EmailLinkAuthentication'


class MenuAppBar extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isAuthorised: this.props.isAuthorised,
      accountMenuIsOpen: false,
      openDrawerMenu:false
    }
    this.renderAuthorisedMenu = this.renderAuthorisedMenu.bind(this);
    this.handleMyProfileClick = this.handleMyProfileClick.bind(this)
  }

  componentWillReceiveProps(nextProps) {
    this.setState({
      isAuthorised:nextProps.isAuthorised,

    })
  }

  handleMenu = event => {
    this.setState({ anchorEl: event.currentTarget });
  };

  handleClose = () => {
    this.setState({ anchorEl: null });
  }

  handleSignIn = () => {
    signIn();
  };


  handleSignOut = () => {
    //this.handleClose()
    signOut();
  };

  navMyEventsClick = () => {
    this.props.history.push('/myevents');
  }

  navNewEventClick = () => {
    this.props.history.push('/events/new');
  }

  openDrawer = () => {
    this.setState({openDrawerMenu:true})
  }

  handleMyProfileClick() {
    this.props.history.push('/myprofile')
  }

  renderManageMyEvents() {
    return (
      <div>
        <MenuItem onClick={this.navNewEventClick}>New Event</MenuItem>
        <MenuItem onClick={this.navMyEventsClick}>My Events</MenuItem>
      </div>
    )
  }

  /* Render*/
  renderAuthorisedMenu() {
    if (this.props.isAuthorising) return null;

    return (
      <div>
        {manageMyEvents() && this.renderManageMyEvents()}
        <MenuItem onClick={this.handleMyProfileClick}>My Profile</MenuItem>
        <MenuItem onClick={this.handleSignOut}>Sign Out</MenuItem>
      </div>
    )
  }

  renderUnAuthorizedMenu() {
    return (
      <MenuItem onClick={this.handleSignIn}>Sign In</MenuItem>
    );
  }

  render() {
    const { isAuthorised } = this.state;
    return (
      <div className="bottom-border">
      <Toolbar >

        <ToolbarRow
          style={{backgroundColor:"white"}}
        >
          <ToolbarSection alignStart style={{minWidth:"250px"}}>
            {/*<ToolbarMenuIcon style={{color:"orange"}} use="menu" onClick={this.openDrawer}/>*/}
            <ToolbarTitle>
            <a href="/">
              <div className="title-network">NETWORK</div>
              <div className="title-buddy">BUDDY</div>
              <div className="title-beta">BETA</div>
            </a>
          </ToolbarTitle>

          </ToolbarSection>
          <ToolbarSection alignEnd>
            <MenuAnchor >
              <ToolbarIcon
                style={{color:"var(--darkOrange)"}}
                use="account_circle"
                onClick={e => this.setState({'accountMenuIsOpen': !this.state.accountMenuIsOpen})}
              />
                <SimpleMenu
                  anchorCorner="bottomStart"
                  open={this.state.accountMenuIsOpen}
                  onClose={evt => this.setState({accountMenuIsOpen: false})}
                >
                  {isAuthorised
                    ?this.renderAuthorisedMenu()
                    :this.renderUnAuthorizedMenu()
                  }
                </SimpleMenu>
            </MenuAnchor>
          </ToolbarSection>
        </ToolbarRow>
      </Toolbar>
      </div>
    );
  }

}

export default (withRouter(MenuAppBar));



// WEBPACK FOOTER //
// ./src/containers/MenuAppBar.js